import { Builder, TranslateFunction } from '@dynamic/ui';
import { t } from 'i18next';
import styled from 'styled-components';

import Button from '#/components/Button/Button';

import { makeFetcher } from '../dynui-fetchers';

export interface BuildDynamicUiParams {
  fontConfig: any;
  translations: any;
  parentalSystem: any;
  formFactor: any;
  v2Templates: any;
}

const StyledButton = styled(Button)`
  padding: 0;
  & > div {
    color: inherit;
  }
`;

const translate: TranslateFunction = (value, opts) => {
  return t(value, opts);
};

const buildDynamicUi = ({
  fontConfig,
  translations,
  parentalSystem,
  formFactor,
  v2Templates,
}: BuildDynamicUiParams) => {
  const fetcher = makeFetcher();

  const { Page, Container, Item } = new Builder()
    .setButtonBase(StyledButton)
    .setFontConfig(fontConfig)
    .setTranslations(translations)
    .setTranslationMethod(translate)
    .setParentalSystem(parentalSystem)
    .setFetchSliderPage(fetcher)
    .setFormFactor(formFactor)
    .setV2Templates(v2Templates)
    .build();

  // TODO: Adjust types with dynamic ui library
  return {
    Page: Page,
    Container: Container,
    Item: Item,
  };
};

export default buildDynamicUi;
